import { getSdk } from './CommercetoolsSDK';

export { getSdk };
